import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { isNull, isNullOrUndefined } from "../../../../utils/utilityFunctions";
import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import BrandPerformanceTableTile from "../BrandPerformanceTableTile";
import { RootStateOrAny, useSelector } from "react-redux";
import { getTPTableData, getTPTrendData } from "../../../../api";

interface Props extends RouteComponentProps {
  diff: number;
  granularity: string;
}

const TPContent = withRouter((props: Props) => {
  const { diff, history, granularity } = props;
  const params = useSelector((state: RootStateOrAny) => state.parameters);
  // fetch the trend and average data
  const {
    data: chartData,
    isFetching: loadingTPTrendData, // call data using react-query
    refetch: refetchTPTrendData,
  } = useQuery(["tpTrendData", granularity, history.location.search], () => getTPTrendData(params), { enabled: false });

  const {
    data: tableData,
    isFetching: loadingTPTableData, // call data using react-query
    refetch: refetchTPTableData,
  } = useQuery(["tpTableData", granularity, history.location.search], () => getTPTableData(params), {
    enabled: false,
  });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchTPTableData();
    refetchTPTrendData();
  }, [history.location.search]);

  const columns = [
    {
      id: "model",
      Header: `Model`,
      accessor: "model",
      defaultCanSort: true,
      sortDescFirst: true,
      sortType: "alphanumericIgnoreCase",
      Cell: (props: { value: string }) => {
        const { value } = props;

        return value;
      },
    },
    {
      Header: "TP",
      accessor: `tp`,
      id: "tp",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: number }) => {
        return isNullOrUndefined(value) ? "n/a" : `${value?.toLocaleString()}`;
      },
    },
  ];

  return (
    <div className="brand-market-main-content">
      <BrandPerformanceTrendTile
        title="TP Trend"
        chartId="tpTrendChart"
        chartData={chartData}
        loadingTrend={loadingTPTrendData}
        diff={diff}
        chartGranularity={granularity}
      />
      <BrandPerformanceTableTile
        title="TP Average"
        tableId="tpTable"
        tableData={tableData}
        columns={columns}
        loadingTable={loadingTPTableData}
        initialSortCol={{ id: "tp", desc: true }}
      />
    </div>
  );
});

export default TPContent;
